module.exports = __webpack_public_path__ + "static/media/charly-fuentes.62bfa9db.jpg";